import { useState, useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

const BookingNotification = () => {
  const [show, setShow] = useState(false);
  const [currentBooking, setCurrentBooking] = useState(null);

  // Sample data for fake bookings
  const sampleBookings = [
    { name: "Michael R.", vehicle: "2019 Toyota Camry", location: "Jacksonville, FL" },
    { name: "Sarah T.", vehicle: "2021 Honda Accord", location: "St. Augustine, FL" },
    { name: "James W.", vehicle: "2020 Ford F-150", location: "Kingsland, GA" },
    { name: "Emily D.", vehicle: "2018 Nissan Altima", location: "Gainesville, FL" },
    { name: "David M.", vehicle: "2022 Mazda CX-5", location: "Brunswick, GA" },
    { name: "Jessica P.", vehicle: "2019 Chevrolet Silverado", location: "Fernandina Beach, FL" },
    { name: "Chris B.", vehicle: "2020 Hyundai Elantra", location: "Valdosta, GA" },
    { name: "Amanda K.", vehicle: "2021 Subaru Outback", location: "Jacksonville, FL" },
    { name: "Robert L.", vehicle: "2019 GMC Sierra", location: "St. Augustine, FL" },
    { name: "Lisa H.", vehicle: "2020 Kia Sportage", location: "Kingsland, GA" }
  ];

  useEffect(() => {
    // Show first notification after 8 seconds
    const initialTimeout = setTimeout(() => {
      showRandomBooking();
    }, 8000);

    // Then show a new notification every 60-90 seconds
    const interval = setInterval(() => {
      showRandomBooking();
    }, Math.random() * 30000 + 60000); // Random between 60-90 seconds

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);

  const showRandomBooking = () => {
    const randomBooking = sampleBookings[Math.floor(Math.random() * sampleBookings.length)];
    setCurrentBooking(randomBooking);
    setShow(true);

    // Hide after 6 seconds
    setTimeout(() => {
      setShow(false);
    }, 6000);
  };

  if (!show || !currentBooking) return null;

  return (
    <div 
      className="fixed bottom-6 left-6 z-50 animate-slide-up"
      style={{
        animation: show ? 'slideUp 0.5s ease-out' : 'slideDown 0.5s ease-out'
      }}
    >
      <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-2xl p-4 flex items-start gap-3 max-w-sm border border-green-500">
        <CheckCircle className="w-6 h-6 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold text-sm mb-1">
            {currentBooking.name} just booked an inspection!
          </p>
          <p className="text-xs text-green-100">
            {currentBooking.vehicle} • {currentBooking.location}
          </p>
          <p className="text-xs text-green-200 mt-1">
            {Math.floor(Math.random() * 10) + 1} minutes ago
          </p>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes slideDown {
          from {
            transform: translateY(0);
            opacity: 1;
          }
          to {
            transform: translateY(100px);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default BookingNotification;
